
import Vue from "vue";
import { Component } from "vue-property-decorator";
import * as ST from "@/components/controls/s-table/exports";
import STable from "@/components/controls/s-table/sTable.vue";
import ItemPickerV2 from "@/components/controls/itemPickerV2.vue";
import TestRecord from "@/components/admin/test/testRecord";
import TextEdit from "@/components/controls/text-edit.vue";
import { DisplayMode, IsNewRow } from "@/components/controls/s-table/exports";
import { restaurantApi } from "@/services/RApiService";
import { Category } from "@/api/restaurant";

@Component({
  components: {
    STable,
  },
})
export default class RCategories extends Vue {
  dataSource: Array<Category> = new Array<Category>();

  tableSettings: ST.Settings<Category> = {
    dataSource: this.dataSource,
    pagination: false,
    showNewRow: true,
    newRowText: "Ny Kategori",
    newRowInit: () => ({ id : -1}),
    recordsUpdated: async (records) => this.postRecord(records),
    loading: false,
    actions: {
      edit: {
        icon: "edit",
        action: (record) => {
          this.editCategory(record);
        },
        visible: (record) => !IsNewRow(record),
      },
      remove: {
        icon: "delete",
        confirmation: (record) =>
          `Är du säker på att du vill ta bort ${record.text}`,
        action: (record) => {
          this.deleteRecord(record);
        },
      },
    },
    columns: [
      {
        title: "Kategori",
        width: 400,
        edit: TextEdit,
        editData: (record) => ({
          editable: true,
          editValue: record.text,
          dataBinding: {
            propertyName: "text",
          },
          updateEmitter: "valueChanged",
          props: {
            defaultOpen: !IsNewRow(record),
            defaultValue: record.text,
            placeHolder: "Namn",
          },
        }),
      },
    ],
  };

  async mounted() {
    var result = await restaurantApi.getCategories();
    this.dataSource.push(...result.data);
  }
  async deleteRecord(record: Category) {
    console.log(record);
    await restaurantApi.deleteCategory(record.id);
    var recordIndex = this.dataSource.indexOf(record, 0);
    if (recordIndex > -1) this.dataSource.splice(recordIndex, 1);
    this.notify("Varan har blivit borttagen", record.text ?? "");
  }
  async postRecord(records: Array<Category>) {
    for (const record of records) {
      var res = await restaurantApi.postCategory(record);
      record.id = res.data.id;
    }
    this.notify("Ändringarna har blivit sparade", "Sparat");
  }
  public notify(description: string, message: string) {
    this.$notification.open({
      message: message,
      description: description,
      placement: "bottomRight",
      duration: 4,
    });
  }
  public editCategory(record: Category) {
    this.$router.push({
      name: "restaurantEditCategory",
      params: { id: record.id!.toString() },
    });
  }
}
